function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.53846 15H14.4615C14.7589 15 15 14.7452 15 14.4309V1.56911C15 1.25479 14.7589 1 14.4615 1H1.53846C1.24112 1 1 1.25479 1 1.56911V14.4309C1 14.7452 1.24112 15 1.53846 15ZM6.38462 2.13821H9.61539V5.20529L8.21673 4.47371C8.06488 4.3942 7.88633 4.39506 7.73513 4.47581L6.38462 5.19687V2.13821ZM2.07692 2.13821H5.30769V6.12195C5.30769 6.3196 5.40472 6.50314 5.56405 6.60672C5.72328 6.71024 5.92208 6.71906 6.08895 6.62994L7.9804 5.62006L9.91504 6.63204C10.0791 6.71786 10.277 6.71109 10.4379 6.60546C10.5961 6.5016 10.6923 6.31875 10.6923 6.12195V2.13821H13.9231V13.8618H2.07692V2.13821Z",
  fill: "#D18F1F"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3077 11.0163H9.07692C8.77958 11.0163 8.53846 11.271 8.53846 11.5854C8.53846 11.8997 8.77958 12.1545 9.07692 12.1545H12.3077C12.605 12.1545 12.8462 11.8997 12.8462 11.5854C12.8462 11.271 12.605 11.0163 12.3077 11.0163Z",
  fill: "#D18F1F"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1.53846 15H14.4615C14.7589 15 15 14.7452 15 14.4309V1.56911C15 1.25479 14.7589 1 14.4615 1H1.53846C1.24112 1 1 1.25479 1 1.56911V14.4309C1 14.7452 1.24112 15 1.53846 15ZM6.38462 2.13821H9.61539V5.20529L8.21673 4.47371C8.06488 4.3942 7.88633 4.39506 7.73513 4.47581L6.38462 5.19687V2.13821ZM2.07692 2.13821H5.30769V6.12195C5.30769 6.3196 5.40472 6.50314 5.56405 6.60672C5.72328 6.71024 5.92208 6.71906 6.08895 6.62994L7.9804 5.62006L9.91504 6.63204C10.0791 6.71786 10.277 6.71109 10.4379 6.60546C10.5961 6.5016 10.6923 6.31875 10.6923 6.12195V2.13821H13.9231V13.8618H2.07692V2.13821Z",
  stroke: "#D18F1F",
  strokeWidth: 0.5
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3077 11.0163H9.07692C8.77958 11.0163 8.53846 11.271 8.53846 11.5854C8.53846 11.8997 8.77958 12.1545 9.07692 12.1545H12.3077C12.605 12.1545 12.8462 11.8997 12.8462 11.5854C12.8462 11.271 12.605 11.0163 12.3077 11.0163Z",
  stroke: "#D18F1F",
  strokeWidth: 0.5
});
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.ab240af114a7d594a95548b0a292810a.svg";
export { ForwardRef as ReactComponent };